import React from 'react'
import HeadingOne from './HeadingOne'

const Caption = ({heading1,leadText}) => {
  return (
        <>  
        <div className="caption">
            <HeadingOne heading1={heading1}/>
            <p className='leadText'>{leadText}</p>
            </div>
        </>
  )
}

export default Caption